export const Loader = () => {
  return (
    <div className="d-flex justify-content-center">
      <img src="../assets/images/loading.gif" alt="Loading" />
    </div>
  )
}
